module.exports = __webpack_public_path__ + "img/yusuf.57065dd7.jpg";